import React from "react";
//
import { useLocation } from "react-router-dom";
import Form from "../../components/Form";
import Dropdown from "../../components/Form/Dropdown";
import IconInput from "../../components/Form/Input";
//
import { useEffect ,useState} from "react";
import { useHistory } from "react-router-dom";


import { connect, useSelector } from "react-redux";
import {
  EVALUATION_CREATE,
  SELL_MY_CAR_STEPS,
  TOASTER_SHOW,
  UPDATE_AUTH,
  toaster_w,
} from "../../constant";
import { POST } from "../../constant/apiMethods";
import Labels from "../../services/apiLabels";
import Step6 from "./Step6";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step7 from "./Step7";
import Step8 from "./Step8";
//
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import { scrollTop } from "../../utils/window";
import { upperCase } from "lodash";
import {
  fetchEvaluationProfileContact,
  getMissingEvaluationContactFields,
  getMissingEvaluationVehicleFields,
  pickEvaluationContact,
} from "../../utils/evaluationContact";
import PhoneWithCountryCode from "../../components/PhoneWithCountryCode";
import {
  getDefaultCountry,
  isCountryEnabled,
  joinPhone,
  splitPhone,
} from "../../utils/countries";
import {
  normalizeChoiceField,
  normalizeTextField,
} from "../../utils/sellMyCarFields";
// 
function EvaluationSteps(props) {
  const {
    currentStep,
    setcurrentStep,
    //
    step1,
    auth,
    //
    setreg_number,
    setmileage,
    setprevious_owners,
    setservices_history,
    //
    setuser_name,
    setuser_email,
    setuser_postcode,
    setuser_mobile_number,
    //
    postEvaluationCreate,
    loading_evaluation_create,
    toasterShow,
    updateAuth,
  } = props;

  // Persisted state can hold raw API values here (saved evaluations), so read
  // through normalisers instead of trusting the wizard shape.
  const reg_number = normalizeTextField(props.reg_number);
  const mileage = normalizeChoiceField(props.mileage);
  const previous_owners = normalizeChoiceField(props.previous_owners);
  const services_history = normalizeChoiceField(props.services_history);
  const user_name = normalizeTextField(props.user_name);
  const user_email = normalizeTextField(props.user_email);
  const user_postcode = normalizeTextField(props.user_postcode);
  const user_mobile_number = normalizeTextField(props.user_mobile_number);
  const formanimationClassname = "animate__animated animate__zoomIn";
  const [fieldErrors, setFieldErrors] = useState({});
  const { feedback } = useContext(FeedbackContext);
  const evaluation_page = feedback.evaluation_page || {};

  const clearFieldError = (key) => {
    setFieldErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const showMissingToast = (missing) => {
    if (!missing.length) return;
    toasterShow({
      show: true,
      autoHide: true,
      type: toaster_w,
      description: `Please fill required fields: ${missing.join(", ")}`,
    });
  };

  const step2OnSubmitHandler = () => {
    const missing = getMissingEvaluationVehicleFields({
      reg_number,
      mileage,
      previous_owners,
      services_history,
      labels: {
        reg: evaluation_page.Registration_Number_heading || "Registration Number",
        mileage: evaluation_page.Mileage_heading || "Mileage",
        owners: evaluation_page.Previous_Owners_heading || "Previous Owners",
        service: evaluation_page.Services_History_label || "Services History",
      },
    });
    const nextErrors = {};
    if (!String(reg_number || "").trim()) nextErrors.reg_number = "Required";
    if (!mileage?.isSelected) nextErrors.mileage = "Required";
    if (!previous_owners?.isSelected) nextErrors.previous_owners = "Required";
    if (!services_history?.isSelected) nextErrors.services_history = "Required";
    setFieldErrors(nextErrors);
    if (missing.length) {
      showMissingToast(missing);
      return;
    }
    setcurrentStep(currentStep + 1);
    scrollTop();
  };
  //
  const [refel_code, setrefel_code] = useState()
  const det_refel_code=(e)=>{
    setrefel_code(e)
  }
  const defaultPhoneCountry = getDefaultCountry();
  const [phoneDial, setPhoneDial] = useState(defaultPhoneCountry.dial);
  const [phoneNational, setPhoneNational] = useState("");
  const [phoneCountry, setPhoneCountry] = useState(defaultPhoneCountry.name);

  const applyPhoneParts = (mobileValue) => {
    const parts = splitPhone(mobileValue || "");
    setPhoneDial(parts.dial);
    setPhoneNational(parts.national);
    if (parts.country?.name) {
      setPhoneCountry(parts.country.name);
    }
    const joined = joinPhone(parts.dial, parts.national);
    if (joined) {
      setuser_mobile_number(joined);
    }
  };

  const onPhoneDialChange = (dial, dialCountry) => {
    clearFieldError("user_mobile_number");
    setPhoneDial(dial);
    if (dialCountry?.name && isCountryEnabled(dialCountry.code)) {
      setPhoneCountry(dialCountry.name);
    }
    setuser_mobile_number(joinPhone(dial, phoneNational));
  };

  const onPhoneNationalChange = (national) => {
    clearFieldError("user_mobile_number");
    setPhoneNational(national);
    setuser_mobile_number(joinPhone(phoneDial, national));
  };

  // Autofill contact details from logged-in user (+ full profile for phone/postcode)
  useEffect(() => {
    if (currentStep !== 3 || !auth?.token) return undefined;

    let cancelled = false;
    const contactRef = {
      name: user_name,
      email: user_email,
      mobile: user_mobile_number,
      postcode: user_postcode,
    };

    const applyContact = (contact, { syncAuth = false } = {}) => {
      if (cancelled || !contact) return;
      if (!contactRef.name && contact.name) {
        contactRef.name = contact.name;
        setuser_name(contact.name);
      }
      if (!contactRef.email && contact.email) {
        contactRef.email = contact.email;
        setuser_email(contact.email);
      }
      if (!contactRef.mobile && contact.mobile) {
        contactRef.mobile = contact.mobile;
        applyPhoneParts(contact.mobile);
      }
      if (!contactRef.postcode && contact.postcode) {
        contactRef.postcode = contact.postcode;
        setuser_postcode(contact.postcode);
      }
      if (
        syncAuth &&
        (contact.email || contact.mobile || contact.postcode)
      ) {
        updateAuth({
          ...(contact.email ? { email: contact.email } : {}),
          ...(contact.mobile ? { mobile_number: contact.mobile } : {}),
          ...(contact.postcode ? { postcode: contact.postcode } : {}),
        });
      }
    };

    // If Redux already has a mobile, still split it into dial + national for the UI.
    if (user_mobile_number) {
      applyPhoneParts(user_mobile_number);
    }

    applyContact(pickEvaluationContact(auth));

    fetchEvaluationProfileContact(auth).then((contact) => {
      applyContact(contact, { syncAuth: true });
    });

    return () => {
      cancelled = true;
    };
    // Intentionally only when entering step 3 / session identity changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, auth?.token, auth?.id]);

  const renderServiceHistoryDetail = (e) => {
    switch (e) {
      case "Full":
        return "All recomended serevices on time ";
      case "Some":
        return "Some recomended serevices are missed ";
      case "None":
        return "No services are done";
      case "First not Due":
        return "Recomended service is due";

      default:
        return "";
    }
  };
  //



const [car_description, setcar_description] = useState()

const [car_notes, setcar_notes] = useState()
const [car_body, setcar_body] = useState({})


  const postEvaluationCreateHandler = () => {
    const joinedMobile =
      joinPhone(phoneDial, phoneNational) ||
      String(user_mobile_number || "").trim();
    if (joinedMobile && joinedMobile !== user_mobile_number) {
      setuser_mobile_number(joinedMobile);
    }

    const contactMissing = getMissingEvaluationContactFields({
      user_name,
      user_email,
      user_postcode,
      user_mobile_number: joinedMobile,
      labels: {
        name: evaluation_page.Your_Name_label || "Your Name",
        email: evaluation_page.Your_Email_label || "Your Email",
        postcode: evaluation_page.Your_Postcode_label || "Your Postcode",
        mobile: evaluation_page.Your_Mobile_Number_label || "Your Mobile Number",
      },
    });
    const vehicleMissing = [];
    if (!step1?.variant?.isSelected) {
      vehicleMissing.push("Vehicle details");
    }
    if (!reg_number) vehicleMissing.push("Registration Number");
    if (!mileage?.isSelected) vehicleMissing.push("Mileage");
    if (!previous_owners?.isSelected) vehicleMissing.push("Previous Owners");
    if (!services_history?.isSelected) vehicleMissing.push("Services History");

    const nextErrors = {};
    if (!String(user_name || "").trim()) nextErrors.user_name = "Required";
    if (!String(user_email || "").trim()) nextErrors.user_email = "Required";
    if (!String(user_postcode || "").trim()) nextErrors.user_postcode = "Required";
    if (!String(joinedMobile || "").trim() || !String(phoneNational || "").trim()) {
      nextErrors.user_mobile_number = "Required";
    }
    setFieldErrors(nextErrors);

    const missing = [...vehicleMissing, ...contactMissing];
    if (missing.length) {
      showMissingToast(missing);
      return;
    }

    postEvaluationCreate({
      car: step1.variant.current.value,
      Mileage: mileage.current.title,
      reg_number,
      plate_country: props.plate_country || undefined,
      Previous_owners: previous_owners.current?.id,
      Service_history: services_history.current?.id,
      Website_user: user_name,
      Email: user_email,
      refel_code: refel_code,
      Postcode: user_postcode,
      Mobile_number: joinedMobile,
      car_description: car_description,
      car_notes: car_notes,
      car_body_type: car_body?.id,
    });
    scrollTop();
  };

  const history = useHistory();
  const evaluationId = useSelector(
    (state) => state.sellMyCar?.evaluation_create?.id
  );

  useEffect(() => {
    if (currentStep !== 4) return undefined;
    history.push(evaluationId ? `/carsteps/${evaluationId}` : "/carsteps");
    return undefined;
  }, [currentStep, evaluationId, history]);



  const location = useLocation();

useEffect(() => {

   


  if(location.state){
    setinputshow(true)

     // result: 'some_value'

    setreg_number(location.state.Car_Reg_N.toUpperCase())
  }





}, [location])

var dis="enabled"

const [inputshow, setinputshow] = useState(false)



  return (
    <>
      {/* ============================== step 2 form ============================== */}
      {currentStep === 2 ? (
        <Form
          width="fluid"
          onSubmit={step2OnSubmitHandler}
          buttonText="Continue"
          buttonClassName="pi-evaluation__submit-btn"
          childClassName="pi-evaluation__fields pi-evaluation__fields--step2"
          className={formanimationClassname}
        >
          {/* Registration Number*/}

          {inputshow ? null : (
            <IconInput
              required
              invalid={Boolean(fieldErrors.reg_number)}
              errorText={fieldErrors.reg_number}
              label={evaluation_page.Registration_Number_heading}
              placeholder={evaluation_page.Registration_Number_placeholder}
              onChangeText={(value) => {
                clearFieldError("reg_number");
                setreg_number(value);
              }}
              value={reg_number.toUpperCase()}
            />
          )}

          {/* mileage */}
          <IconInput
            required
            invalid={Boolean(fieldErrors.mileage)}
            errorText={fieldErrors.mileage}
            label={evaluation_page.Mileage_heading}
            placeholder={evaluation_page.Mileage_placeholder}
            onChangeText={(e) => {
              clearFieldError("mileage");
              setmileage({
                ...mileage,
                isSelected: e.length > 0,
                current: { id: "", title: e },
              });
            }}
            value={normalizeTextField(mileage.current.title)}
          />
          {/* previous_owners */}
          <Dropdown
            required
            invalid={Boolean(fieldErrors.previous_owners)}
            errorText={fieldErrors.previous_owners}
            label={evaluation_page.Previous_Owners_heading}
            onSelect={(item) => {
              clearFieldError("previous_owners");
              setprevious_owners({
                ...previous_owners,
                isSelected: true,
                current: item,
              });
            }}
            selectedValue={previous_owners.current}
            loading={previous_owners.fetching}
            disabled={false}
            data={[
              { title: "None", id: 7 },
              { title: 1, id: 1 },
              { title: 2, id: 2 },
              { title: 3, id: 3 },
              { title: 4, id: 4 },
              { title: "5 or more", id: 5 },
              { title: "Don't know", id: 6 },
            ]}
          />
          {/* ======================orinal code  */}
          {/* services_history */}
          <Dropdown
            required
            invalid={Boolean(fieldErrors.services_history)}
            errorText={fieldErrors.services_history}
            label={evaluation_page.Services_History_label}
            onSelect={(item) => {
              clearFieldError("services_history");
              setservices_history({
                ...services_history,
                isSelected: true,
                current: item,
              });
            }}
            selectedValue={services_history.current}
            loading={services_history.fetching}
            disabled={false}
            data={[
              { title: "Full", id: 1 },
              { title: "Part", id: 2 },
              { title: "None", id: 3 },
              { title: "First not Due", id: 4 },
            ]}
          />
          {services_history.isSelected ? (
            <p className="pi-evaluation__field-hint">
              {renderServiceHistoryDetail(services_history.current.title)}
            </p>
          ) : null}
        </Form>
      ) : null}
      {/* ============================== step 3 form ============================== */}
      {currentStep === 3 ? (
        <Form
          width="fluid"
          onSubmit={postEvaluationCreateHandler}
          buttonText={evaluation_page.Get_my_valuation_buton_text}
          buttonClassName="pi-evaluation__submit-btn"
          childClassName="pi-evaluation__fields pi-evaluation__fields--step3"
          className={formanimationClassname}
          loading={loading_evaluation_create}
          loadingText={evaluation_page.Get_my_valuation_buton_text_loading}
          onBack={() => {
            setcurrentStep(2);
            scrollTop();
          }}
        >
          {/* uesr name */}
          <IconInput
            required
            invalid={Boolean(fieldErrors.user_name)}
            errorText={fieldErrors.user_name}
            loading={loading_evaluation_create}
            label={evaluation_page.Your_Name_label}
            placeholder={evaluation_page.Your_Name_placeholder}
            onChangeText={(value) => {
              clearFieldError("user_name");
              setuser_name(value);
            }}
            value={user_name}
          />
          {/* uesr email */}
          <IconInput
            required
            invalid={Boolean(fieldErrors.user_email)}
            errorText={fieldErrors.user_email}
            loading={loading_evaluation_create}
            type="email"
            label={evaluation_page.Your_Email_label}
            placeholder={evaluation_page.Your_Email_placeholder}
            onChangeText={(value) => {
              clearFieldError("user_email");
              setuser_email(value);
            }}
            value={user_email}
          />
          {/* uesr postcode */}
          <IconInput
            required
            invalid={Boolean(fieldErrors.user_postcode)}
            errorText={fieldErrors.user_postcode}
            style={{ textTransform: upperCase }}
            loading={loading_evaluation_create}
            label={evaluation_page.Your_Postcode_label}
            placeholder={evaluation_page.Your_Postcode_placeholder}
            onChangeText={(value) => {
              clearFieldError("user_postcode");
              setuser_postcode(value);
            }}
            value={user_postcode.toUpperCase()}
          />

          {/* ===========================refel code =========== */}
          {/* <IconInput
            style={{ textTransform: upperCase }}
            label={evaluation_page.Your_referal_label}
            placeholder={evaluation_page.Your_referal_placeholder}
            onChangeText={det_refel_code}
            value={refel_code}
          /> */}
          {/* uesr mobile_number */}
          <div
            className={`dropdown_wrapper pi-form-field${
              fieldErrors.user_mobile_number ? " is-invalid" : ""
            }`}
          >
            <label className="pi-form-field__label" htmlFor="evaluation-mobile">
              {evaluation_page.Your_Mobile_Number_label}
              <span className="pi-form-field__required" aria-hidden="true">
                *
              </span>
            </label>
            <PhoneWithCountryCode
              id="evaluation-mobile"
              dial={phoneDial}
              national={phoneNational}
              countryName={phoneCountry}
              onDialChange={onPhoneDialChange}
              onNationalChange={onPhoneNationalChange}
              disabled={loading_evaluation_create}
              required
            />
            {fieldErrors.user_mobile_number ? (
              <p className="pi-form-field__error" role="alert">
                {fieldErrors.user_mobile_number}
              </p>
            ) : null}
          </div>
            <Dropdown
            label={evaluation_page.Car_Body_Type_label || "Car Body Type"}
            onSelect={(item) =>
              setcar_body(item)
            }
            selectedValue={car_body}
            loading={services_history.fetching}
            disabled={false}
            data={[
              { title: "Hatchback", id: 1 },
              { title: "SUV", id: 2 },
              { title: "Saloon", id: 3 },
            ]}
          />
          {/* <div className="dropdown_wrapper">
            <span className="label-t "> {evaluation_page.Your_Description}</span>
            <textarea
              className="text-area mt-1 mb-1 p-1"
              id="w3review"
              name="w3review"
              rows="3"
              placeholder={evaluation_page.Your_Description_Placeholder}
              value={car_description}
              cols="50"
              onChange={(e) => {
                setcar_description(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="dropdown_wrapper">
            <span className="label-t  "> {evaluation_page.Your_Notes}</span>
            <textarea
              className="text-area mt-1 p-1"
              id="w3review"
              name="w3review"
              rows="3"
              cols="50"
              placeholder= {evaluation_page.Your_Notes_palceholder}
              value={car_notes}
              onChange={(e) => {
                setcar_notes(e.target.value);
              }}
            ></textarea>
          </div> */}
        </Form>
      ) : null}
      <div className="w-100" style={{ padding: "0.5rem" }}>
        {/* Redirect to Car Steps when evaluation create finishes (currentStep === 4). */}
      </div>
      {/* <button onClick={() => setcurrentStep(currentStep - 1)}>Back</button>
      <button onClick={() => setcurrentStep(currentStep + 1)}>forward</button> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading_evaluation_create: state.sellMyCar.loading,
  step1: state.sellMyCar.step1,
  reg_number: state.sellMyCar.step2.reg_number,
  plate_country: state.sellMyCar.step2.plate_country,
  mileage: state.sellMyCar.step2.mileage,
  previous_owners: state.sellMyCar.step2.previous_owners,
  services_history: state.sellMyCar.step2.services_history,
  // step 3 user info
  user_name: state.sellMyCar.user.name,
  user_email: state.sellMyCar.user.email,
  user_postcode: state.sellMyCar.user.postcode,
  user_mobile_number: state.sellMyCar.user.mobile_number,
});
const mapDispatchToProps = (dispatch) => ({
  setmileage: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "mileage",
        data,
      },
    }),
  setprevious_owners: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "previous_owners",
        data,
      },
    }),
  setservices_history: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "services_history",
        data,
      },
    }),
  setreg_number: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "reg_number",
        data,
      },
    }),
  // step 4
  setuser_name: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_name",
        data,
      },
    }),
  setuser_email: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_email",
        data,
      },
    }),
  setuser_postcode: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_postcode",
        data,
      },
    }),
  setuser_mobile_number: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_mobile_number",
        data,
      },
    }),
  // post EVALUATION_CREATE
  postEvaluationCreate: (data) => {
    return dispatch({
      type: EVALUATION_CREATE,
      payload: {
        type: EVALUATION_CREATE,
        method: POST,
        label: `${Labels.evaluation_create}`,
        hideOverlayLoader: true,
        data,
      },
    });
  },
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: data,
    }),
  updateAuth: (payload) =>
    dispatch({
      type: UPDATE_AUTH,
      payload: { ...(payload || {}) },
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(EvaluationSteps);
